<div class="switch-button">
    <ng-container *ngFor="let link of links;">
        <!--[role]="'button'" -> it's this way to resolve sreen reader issue in safari-->
        <finder-anchor
            [internal]="true"
            [href]="link.href"
            [role]="'button'"
            [ariaPressed]="isSelected(link.id)"
            (click)="setSelected(link.id)"
            [ngClass]="{'active': isSelected(link.id)}">
            {{link.text}}
        </finder-anchor>
    </ng-container>
</div>
